const shelterPageSlider = () => {
  const pageSlider = $('.page-slider');
  const pageSettings = {
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow: $('.page-prev'),
    nextArrow: $('.page-next'),
    responsive: [
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  pageSlider.slick(pageSettings);
  $(window).on('resize', function () {
    if ($(window).width() > 820) {
      return;
    }
    if (!pageSlider.hasClass('slick-initialized')) {
      return pageSlider.slick(pageSettings);
    }
  });

  // $(document).ready(function () {
  $(() => {
    // shelters modal for slider
    $('.modal-but').on('click', function () {
      let dataId = $(this).attr('data-id');
      $('.modal[data-id=' + dataId + ']').css('display', 'block');
    });
    $('.modal-close').on('click', function () {
      $('.modal').css('display', 'none');
    });
  });
  // });
};

export default shelterPageSlider;
